jQuery(document).ready(function($) {
    $(function() {
        $('.lazy').lazy();
    });
});